module.exports = __webpack_public_path__ + "img/huawan.8484196.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huawan.png
// module id = evvB
// module chunks = 1